import { AxiosResponse } from "axios"

export const extract = <T>(r: AxiosResponse<T>) => r.data
